// productReducer.tsx - PERFORMANCE OPTIMIZED VERSION

import { SET_PRODUCTS_CACHE, SET_PRODUCTS_LOADING } from "../actions/actionTypes";
import logger from "../utils/logger";

interface ProductI {
    products: Array<any>;
    isLoading: boolean;
    lastUpdated?: string;
}

const initialState: ProductI = {
    products: [],
    isLoading: false,
    lastUpdated: undefined
}

const productReducer = (state: ProductI = initialState, action: { type: string; payload: any; }): ProductI => {
    // ✅ ONLY log for actual product actions, not system Redux actions
    switch(action?.type) {
        case SET_PRODUCTS_CACHE:
            logger.log('🛒 Product Reducer - Storing products:', action?.payload?.length || 0);
            return {
                ...state,
                products: action?.payload || [],
                isLoading: false,
                lastUpdated: new Date().toISOString()
            }
        case SET_PRODUCTS_LOADING:
            logger.log('🛒 Product Reducer - Setting loading state:', action?.payload);
            return {
                ...state,
                isLoading: action?.payload
            }
        default:
            // ✅ REMOVED: Excessive logging for system actions
            // ❌ Old: logger.log('🛒 Product Reducer - Unknown action, returning current state');
            return state;
    }
}

export default productReducer;